import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Table/sgds-table-row";
import { register } from "../../utils/ce-registry";

register("sgds-table-row", Component);

export default createComponent({
  react: React,
  tagName: "sgds-table-row",
  elementClass: Component,
  events: {}
});
